// extracted by mini-css-extract-plugin
export default {"privacy":"Ship_privacy__HPBKV","listLink":"Ship_listLink__KJXnd"};